import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { history } from 'store/configureStore';
import AuthedBreadcrumb from './authedBreadcrumb';
import { admAccounts, programFiles } from 'const';

const Breadcrumb = () => {
  const routes = [];
  for ( const ii in admAccounts ) {
    routes.push(<Route exact key={ii} path={admAccounts[ii]}  component={AuthedBreadcrumb}></Route>);
  }
  for ( const ii in programFiles ) {
    routes.push(<Route exact key={ii} path={programFiles[ii]}  component={AuthedBreadcrumb}></Route>);
  }
  return (
    <ConnectedRouter history={history}>
      <Switch>
        {routes}
      </Switch>
    </ConnectedRouter>
  );
};

export default Breadcrumb;